var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"name":"unknownNetworkModal","height":"auto","adaptive":true}},[_c('div',{staticClass:"network-unknown-modal"},[_c('div',{staticClass:"ui basic segment center aligned"},[_c('h2',{staticClass:"ui header"},[_vm._v("Connect to Main Ethereum Network")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b35e87a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/UnknownNetworkModal.vue
// module id = null
// module chunks = 